/**
 * Pestana Movimientos de Inventario (INV-01): la libreta, con filtros por
 * producto, motivo y fechas. Es la que contesta "por que quedan 95 y no 100".
 */
import { useSearchParams } from 'react-router-dom';

import { usePeticion } from '../../hooks/use-peticion';
import { obtenerMovimientos } from '../../servicios/administracion.servicio';
import { numero } from '../../utilidades/formato';
import {
  chipsLibreta,
  escribirFiltros,
  leerFiltrosLibreta,
} from '../../utilidades/filtros-inventario';
import type { FiltrosLibreta as Filtros } from '../../utilidades/filtros-inventario';
import { rutas } from '../../utilidades/rutas';
import { Paginador } from '../catalogo/Paginador';
import { AvisoError, Cargando } from '../comunes/EstadoPeticion';
import { FiltrosActivos } from './FiltrosActivos';
import { FiltrosLibreta } from './FiltrosLibreta';
import { TablaMovimientos } from './TablaMovimientos';

export function VistaMovimientos() {
  const [parametros, setParametros] = useSearchParams();
  const pagina = Number(parametros.get('pagina') ?? '1');
  const filtros = leerFiltrosLibreta(parametros);
  const consulta = escribirFiltros('movimientos', filtros).toString();
  const chips = chipsLibreta(filtros);

  const movimientos = usePeticion(
    (senal) => obtenerMovimientos({ ...filtros, pagina }, senal),
    [pagina, consulta],
  );

  function aplicar(siguientes: Filtros): void {
    setParametros(escribirFiltros('movimientos', siguientes));
  }

  const rutaListado = `${rutas.administracion.inventario()}?${consulta}`;

  return (
    <>
      <FiltrosLibreta filtros={filtros} onCambiar={aplicar} />
      <FiltrosActivos
        activos={chips}
        onCambiar={aplicar}
        onLimpiar={() => {
          aplicar({});
        }}
      />

      {movimientos.estado === 'cargando' && movimientos.datos === null ? (
        <Cargando que="los movimientos" />
      ) : null}
      {movimientos.estado === 'error' ? <AvisoError error={movimientos.error} /> : null}

      {movimientos.datos !== null ? (
        movimientos.datos.items.length === 0 && chips.length > 0 ? (
          <div className="panel-vacio" role="status">
            <p>Ningun movimiento cumple estos filtros.</p>
            <button
              type="button"
              className="btn btn-sm btn-contorno"
              onClick={() => {
                aplicar({});
              }}
            >
              Limpiar filtros
            </button>
          </div>
        ) : (
          <>
            <p className="conteo-resultados">
              {numero(movimientos.datos.total)}{' '}
              {movimientos.datos.total === 1 ? 'movimiento' : 'movimientos'}
              {chips.length > 0 ? ' con estos filtros' : ' en la libreta'}
            </p>
            <TablaMovimientos movimientos={movimientos.datos.items} />
            <Paginador
              pagina={movimientos.datos.pagina}
              total={movimientos.datos.total}
              porPagina={movimientos.datos.porPagina}
              ruta={rutaListado}
            />
          </>
        )
      ) : null}
    </>
  );
}
